/**
 * 首次进入应用时的链接解析, 并做对应的信息设置和存储
 */

import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import { parseUrl, isBrowser, TOKEN_SECRET } from '@mc/base';
import { aesEncode } from '@mc/encryption';

if (isBrowser()) {
  /** 解析路径上的参数 */
  const { a8 } = parseUrl(window.location.href).query;
  /** a8 账号id */
  const pid = 's00000024524001';
  const A8CookieName = `_a8_${pid}`;

  if (a8) {
    const a8Cookie = JSON.stringify({
      a8: a8,
      expireTime: dayjs().add(1, 'month').valueOf(),
    });

    Cookies.set(A8CookieName, aesEncode(a8Cookie, TOKEN_SECRET), { domain: '.notta.ai', expires: 30 });

    /** 移除路由参数 不触发页面刷新 */
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}
